module.exports = __webpack_public_path__ + "img/globe.00d48790.svg";